import { Avatar, Box, Dialog, IconButton, Link, Typography } from '@mui/material'
import type React from 'react'
import { MButton } from 'components'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip'
import CloseIcon from '@mui/icons-material/Close'

interface PrivacyDialogProps {
    open: boolean
    handleClick: () => void
}

export const PrivacyDialog: React.FC<PrivacyDialogProps> = ({ open, handleClick }) => {
    const isMobile = useMobileBreakpoints()
    const handleLogin = (): void => {
        handleClick()
    }

    return (
        <Dialog
            open={open}
            onClose={handleClick}
            PaperProps={{
                sx: {
                    width: isMobile ? '90%' : '80%',
                    maxWidth: '100%',
                    m: 2
                }
            }}
        >
            <IconButton
                onClick={handleClick}
                sx={{ position: 'absolute', right: 8, top: 8 }}>
                <CloseIcon />
            </IconButton>
            <Box px={isMobile ? 5 : 5} py={7} maxWidth='100%'>
                <Box display='flex' flexDirection='column' alignItems='center'>
                    <Avatar sx={{ background: '#0092bd', p: 3 }}>
                        <PrivacyTipIcon sx={{ fontSize: 50, color: '#fff' }} />
                    </Avatar>
                </Box>
                <Box mt={2}>
                    <Typography textTransform="capitalize" textAlign="center" fontSize={isMobile ? 18 : 24} fontWeight={600} mb={5}>Privacy Policy</Typography>
                    <Typography textAlign="center" fontSize={18} fontWeight={600} mb={1}>Utility Notification Enrollment</Typography>
                    <Typography textAlign="center" fontSize={16} fontWeight={400} mb={2}>Customers are automatically enrolled to receive important account and service notifications by text message upon establishing service with AlexRenew.<br /> These notifications may include billing reminders, payment confirmations, outage alerts, and other service-related updates.</Typography>
                    <Typography textAlign="center" fontSize={16} fontWeight={400} mb={2}><b>Message and data rates may apply.</b>  Message frequency varies by account activity.</Typography>
                    <Typography textAlign="center" fontSize={16} fontWeight={400} mb={2}>Customers <b>may opt out at any time</b> by replying <b>STOP</b> to any message or by contacting AlexRenew Customer Service at <Link href="mailto:communications@alexrenew.com">communications@alexrenew.com</Link>.<br /> Reply <b>HELP</b> for additional information.</Typography>
                    <Typography textAlign="center" fontSize={16} fontWeight={400} mb={2}>AlexRenew does <b>not share, sell, rent, or use</b> customer mobile information for marketing or promotional purposes.<br /> Mobile numbers are used solely to provide utility-related information and account services.</Typography>
                    <Typography textAlign="center" fontSize={16} fontWeight={400} mb={2}>By initiating utility service, customers consent to receive text messages as described in this policy.</Typography>
                </Box>
                <Box mt={3} textAlign="center">
                    <MButton
                        variant="contained"
                        size="large"
                        rounded="true"
                        texttransform="none"
                        sx={{ width: '200px' }}
                        onClick={handleLogin}
                    >
                        Go Back
                    </MButton>
                </Box>
            </Box>
        </Dialog>
    )
}
